import { render, staticRenderFns } from "./Importing.vue?vue&type=template&id=c3dda818&scoped=true&"
import script from "./Importing.vue?vue&type=script&lang=ts&"
export * from "./Importing.vue?vue&type=script&lang=ts&"
import style0 from "./Importing.vue?vue&type=style&index=0&id=c3dda818&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3dda818",
  null
  
)

export default component.exports